'use client';

import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import useUser from '@alltrails/context/hooks/useUser';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import useExperiments from '@alltrails/experiments/hooks/useExperiments';
import Footer from '../Footer';

type FooterWrapperProps = {
  pageReloadOnLanguageChange?: boolean;
};

const FooterWrapper = ({ pageReloadOnLanguageChange }: FooterWrapperProps) => {
  const languageRegionCode = useLanguageRegionCode();
  const user = useUser();
  const irclickid = useSelector((state: { irclickid: string }) => state.irclickid);
  const intl = useIntl();
  const experiments = useExperiments();

  return (
    <div>
      <Footer
        intl={intl}
        user={user}
        wideFooter={false} // only explore pages use a wide footer
        languageRegionCode={languageRegionCode}
        irclickid={irclickid}
        pageReloadOnLanguageChange={pageReloadOnLanguageChange}
        experiments={experiments}
      />
    </div>
  );
};

export default FooterWrapper;
